// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"772856b3","160":"f4f742d6","208":"3228795a","293":"a66515d5","516":"58f97468","519":"3ff9ba76","917":"6602649e","946":"a8fe8956"}[chunkId] + ".chunk.js";
};